<sabis-ngx-dialog [scTitle]="title">

  <div modal-body>
    @for (message of messages; track message) {
      <p style="word-break: break-word">
        {{ message }}
      </p>
    }
  </div>
  <div modal-footer>
    @for (button of buttons; track button) {
      <sabis-ngx-button (click)="onActionButtonClick(button)">
        {{ button.name }}
      </sabis-ngx-button>
    }
  </div>

</sabis-ngx-dialog>
